import { z } from "zod";
import { schemes } from "../schema-validation";
import { EPartnerInformationSection } from "./EPartnerInformationSection";

export const partnerInformationSectionSchema = z.object({
  name: z.nativeEnum(EPartnerInformationSection),
});

export const partnerShareableLinksTokenPayloadSchema = z.object({
  whiteLabelID: z.string(),
  isShareableLink: z.literal(true),
  sections: z.array(partnerInformationSectionSchema),
  testMode: z.boolean(),
});

export const partnerInformationPartnerSchema = z.object({
  white_label_id: schemes.partnerID(),
  business_name: z.string(),
  business_address: z.string(),
  business_address_line2: z.string(),
  business_city: z.string(),
  business_state: z.string(),
  business_zip: z.string(),
  business_phone: z.string(),
  business_email: z.string(),
  business_description: z.string(),
  legal_structure: z.string(),
  business_ein: z.string(),
  isMailingAddressDifferent: z.boolean(),
  mail_address: z.string(),
  mail_address_line2: z.string(),
  mail_city: z.string(),
  mail_state: z.string(),
  mail_zip: z.string(),
  isPhysicalAddressDifferent: z.boolean(),
  physical_address: z.string(),
  physical_address_line2: z.string(),
  physical_city: z.string(),
  physical_state: z.string(),
  physical_zip: z.string(),
  dba: z.string(),
});

export const partnerInformationPayloadSchema = z.object({
  partner: partnerInformationPartnerSchema,
  logoURL: z.string().nullish(),
  tokenPayload: partnerShareableLinksTokenPayloadSchema,
});

export type TPartnerShareableLinksTokenPayload = z.infer<
  typeof partnerShareableLinksTokenPayloadSchema
>;

export type TPartnerShareableLinksSection = z.infer<
  typeof partnerInformationSectionSchema
>;

export type TPartnerInformationPayload = z.infer<
  typeof partnerInformationPayloadSchema
>;
